import { Expose, Transform } from 'class-transformer'
import { Entity } from '@/app/common/base/entity'

export class InvoiceLine extends Entity<InvoiceLine> {
    // Accelerate indents discount descriptions with spaces for the PDF layout,
    // which renders here as a hanging indent on a description that wraps.
    @Expose()
    @Transform(value => (value || '').trim())
    description!: string

    @Expose()
    amount!: number

    @Expose({ name: 'is_discount' })
    @Transform(value => value || false)
    isDiscount!: boolean
}
